const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const LOWER = 'abcdefghijkmnopqrstuvwxyz';
const DIGITS = '23456789';
const SYMBOLS = '!@#$%^&*_-+=';

const randomFrom = pool => {
  const values = new Uint32Array(1);
  window.crypto.getRandomValues(values);
  return pool[values[0] % pool.length];
};

/**
 * Builds a password that satisfies Chatwoot's own rules: at least one
 * uppercase letter, one lowercase letter, one digit and one symbol.
 * Look-alike characters (O/0, l/1) are left out so it can be read aloud.
 */
export const generateStrongPassword = (length = 14) => {
  const all = UPPER + LOWER + DIGITS + SYMBOLS;
  const required = [
    randomFrom(UPPER),
    randomFrom(LOWER),
    randomFrom(DIGITS),
    randomFrom(SYMBOLS),
  ];

  const rest = Array.from(
    { length: Math.max(length - required.length, 4) },
    () => randomFrom(all)
  );

  return [...required, ...rest]
    .map(char => ({ char, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(entry => entry.char)
    .join('');
};

export default { generateStrongPassword };
